<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-text-field hide-details solo flat single-line dense v-model="formattedDate" :label="label" readonly v-on="on" class="date-picker-text-input"></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      :locale="locale"
      v-model="internalDate"
      :max="max"
      :min="min"
      @change="save"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import dayjs from '../plugins/dayjs';

export default {
  props: {
    label: {
      type: String,
    },
    displayFormat: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    locale: {
      type: String,
    },
    min: {
      type: String,
    },
    max: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  data: () => ({
    menu: false,
    internalDate: null,
  }),
  mounted() {
    this.internalDate = this.value;
  },
  computed: {
    formattedDate() {
      return dayjs(this.internalDate).format(this.displayFormat);
    },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date);
      this.$emit('input', date);
    },
  },
};
</script>

<style lang="scss">
  .date-picker-text-input .v-input__control {
    min-height: auto !important;
  }
</style>
